<template>
    <div>
        <b-button
            variant="default"
            title="Edit"
            @click="$bvModal.show(editModalId)"
            class="mr-1"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            v-if="params.data.can_delete"
            variant="default"
            title="Delete"
            @click="$bvModal.show(deleteModalId)"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal :id="deleteModalId" title="Delete Package" @ok="deletePackage">
            Are you sure you want to delete this package?
        </modal>
        <create-edit-package-modal
            ref="edit_form"
            :packageData="packageData"
            :modalId="editModalId"
            modalTitle="Edit Package"
            @submit="updatePackage"
        ></create-edit-package-modal>
    </div>
</template>

<script>
import modal from '../../generic/modal/modal.vue';
import CreateEditPackageModal from './create-edit-package-modal.vue';
export default {
    components: { CreateEditPackageModal, modal },
    methods: {
        deletePackage() {
            this.params.deletePackage &&
                this.params.deletePackage(this.params.data.id);
        },
        updatePackage(value) {
            this.params.updatePackage &&
                this.params.updatePackage(
                    this.params.data.id,
                    value,
                    this.editModalId,
                    this.$refs.edit_form
                );
        },
    },
    computed: {
        editModalId() {
            return 'edit-package-modal' + this.params.data.id;
        },
        deleteModalId() {
            return 'delete-package-modal' + this.params.data.id;
        },
        packageData() {
            const { id, ...formObject } = this.params.data;
            return {
                ...formObject,
            };
        },
    },
};
</script>